import { render, staticRenderFns } from "./OrderShareFans.vue?vue&type=template&id=e448b1b6"
import script from "./OrderShareFans.vue?vue&type=script&lang=js"
export * from "./OrderShareFans.vue?vue&type=script&lang=js"
import style0 from "./OrderShareFans.vue?vue&type=style&index=0&id=e448b1b6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports